import { render, staticRenderFns } from "./RegistrationContainer.vue?vue&type=template&id=168deeaa&scoped=true&"
import script from "./RegistrationContainer.vue?vue&type=script&lang=js&"
export * from "./RegistrationContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168deeaa",
  null
  
)

export default component.exports